export class RootWiseCostActivateReq{
    id: number;
    updatedUser: string;
    versionFlag: number;
    isActive: boolean;

    constructor( id: number,updatedUser: string,versionFlag: number,isActive: boolean){
        this.id = id
        this.updatedUser = updatedUser
        this.versionFlag = versionFlag
        this.isActive = isActive
    }
}